// frontend/src/pages/reports/OfficerPerformanceReport.js
import React, { useEffect, useState } from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, Typography, TextField, InputAdornment, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import ReportTemplate from '../../components/reports/ReportTemplate';
import { getOfficerPerformanceReport } from '../../services/reportService';

const OfficerPerformanceReport = () => {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [search, setSearch]   = useState('');
  const [zoneFilter, setZoneFilter] = useState('ALL');

  const load = async () => {
    setLoading(true); setError('');
    try { const res = await getOfficerPerformanceReport(); setData(res.data.data); }
    catch (err) { setError(err.response?.data?.message || 'Failed to load report'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const allOfficers = data?.officers || [];
  const zones = ['ALL', ...new Set(allOfficers.map(o => o.assignedZone).filter(z => z !== '-'))];
  const officers = allOfficers.filter(o => {
    const matchSearch = o.officerName.toLowerCase().includes(search.toLowerCase()) || (o.serviceNumber||'').toLowerCase().includes(search.toLowerCase());
    const matchZone = zoneFilter === 'ALL' || o.assignedZone === zoneFilter;
    return matchSearch && matchZone;
  });

  const summary = data?.summary;
  const summaryItems = summary ? [
    { label: 'Total Officers',     value: summary.totalOfficers,                          color: 'primary.main', bg: '#e3f2fd' },
    { label: 'Active Officers',    value: summary.activeOfficers,                         color: 'success.main', bg: '#e8f5e9' },
    { label: 'Total Verifications',value: summary.totalVerifications?.toLocaleString(),   color: 'info.main',    bg: '#e0f7fa' },
    { label: 'Top Officer',        value: summary.topOfficer?.officerName || '-',         color: 'warning.main', bg: '#fff3e0' },
  ] : [];

  const exportCols = [
    { key:'officerName', label:'Officer Name' }, { key:'serviceNumber', label:'Service Number' },
    { key:'assignedZone', label:'Zone' }, { key:'totalVerified', label:'Total Verified' },
    { key:'activeDays', label:'Active Days' }, { key:'avgPerDay', label:'Avg Per Day' },
    { key:'highestDay', label:'Best Day Count' },
    { key:'firstVerification', label:'First Verification' }, { key:'lastVerification', label:'Last Verification' },
  ];

  return (
    <ReportTemplate title="Officer Performance Report" subtitle={data?.exercise ? `${data.exercise.name} — ${data.exercise.year}` : ''}
      loading={loading} error={error} onRefresh={load}
      exportFileName="Officer_Performance_Report" exportData={allOfficers} exportColumns={exportCols}
      summaryItems={summaryItems}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Box display="flex" gap={2} mb={2} flexWrap="wrap">
          <TextField size="small" placeholder="Search officer..." value={search}
            onChange={(e) => setSearch(e.target.value)} sx={{ flex:1, minWidth:200 }}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }} />
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel>Zone</InputLabel>
            <Select value={zoneFilter} label="Zone" onChange={(e) => setZoneFilter(e.target.value)}>
              {zones.map((z) => <MenuItem key={z} value={z}>{z}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor:'grey.100' }}>
              <TableCell><strong>#</strong></TableCell>
              {['Officer','Service No.','Zone','Total Verified','Active Days','Avg/Day','Best Day','First','Last'].map(h =>
                <TableCell key={h} align={['Total Verified','Active Days','Avg/Day','Best Day'].includes(h)?'right':'left'}><strong>{h}</strong></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {officers.map((o, idx) => (
              <TableRow key={o.id} hover sx={{ bgcolor: idx===0 ? '#fffde7' : 'inherit' }}>
                <TableCell sx={{color:'text.secondary'}}>{idx+1}</TableCell>
                <TableCell><Typography variant="body2" fontWeight="bold">{o.officerName}{idx===0&&<span style={{marginLeft:6}}>🏆</span>}</Typography></TableCell>
                <TableCell>{o.serviceNumber}</TableCell>
                <TableCell>{o.assignedZone}</TableCell>
                <TableCell align="right" sx={{color:'success.main',fontWeight:'bold',fontSize:'1rem'}}>{o.totalVerified}</TableCell>
                <TableCell align="right">{o.activeDays}</TableCell>
                <TableCell align="right">{o.avgPerDay}</TableCell>
                <TableCell align="right" sx={{color:'primary.main',fontWeight:'bold'}}>{o.highestDay}</TableCell>
                <TableCell><Typography variant="caption">{o.firstVerification ? new Date(o.firstVerification).toLocaleDateString('en-GB') : '-'}</Typography></TableCell>
                <TableCell><Typography variant="caption">{o.lastVerification  ? new Date(o.lastVerification).toLocaleDateString('en-GB')  : '-'}</Typography></TableCell>
              </TableRow>
            ))}
            {officers.length === 0 && <TableRow><TableCell colSpan={10} align="center" sx={{py:4,color:'text.secondary'}}>No officers found</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Paper>
    </ReportTemplate>
  );
};
export default OfficerPerformanceReport;